import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import auth from 'lib/authentication';
import { getActiveStudent } from 'helpers/guardian';
import { v4 as uuidv4 } from 'uuid';
import store from '../index';
var configSettings = require('../../app-config/config');
var config = configSettings.GET_CONFIG();
var http = axios.create({
  baseURL: config.API + "/api"
});
function delay(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}
var _addToast = function _addToast(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';
  var error = {
    msg: message,
    type: type,
    target: 'API'
  };
  store.dispatch({
    type: 'ADD_ERROR',
    payload: error
  });
};
var interceptor = http.interceptors.response.use(function (response) {
  if (response.status == 204) {
    response.data = null;
  }
  return response;
}, /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
    var _error$response;
    var isNetworkError, max_retries, currentRetries, backoffTime;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          isNetworkError = (error === null || error === void 0 ? void 0 : error.message) === 'Network Error' || (error === null || error === void 0 ? void 0 : error.response) && (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 0;
          if (!isNetworkError) {
            _context.next = 3;
            break;
          }
          max_retries = 2;
          if (error.config.headers['Retries'] == null) {
            error.config.headers['Retries'] = '0';
          }
          currentRetries = parseInt(error.config.headers['Retries']);
          if (!(currentRetries >= max_retries)) {
            _context.next = 1;
            break;
          }
          _addToast("You seem to have lost connection to the server. You can keep working as usual while we're trying to reconnect you.", 'error');
          return _context.abrupt("return", Promise.reject(error));
        case 1:
          if (currentRetries === 0) {
            _addToast("Lost connection to server. Trying to reconnect...", 'warning');
          }
          backoffTime = (currentRetries + 1) * 1000;
          _context.next = 2;
          return new Promise(function (resolve) {
            return setTimeout(resolve, backoffTime);
          });
        case 2:
          error.config.headers['Retries'] = (currentRetries + 1).toString();
          return _context.abrupt("return", http(error.config));
        case 3:
          return _context.abrupt("return", Promise.reject(error));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());

/**
 * @param {import('history').History} history - from useHistory() hook
 */
export var setupInterceptors = function setupInterceptors(history) {
  http.interceptors.request.use(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(config) {
      var writeMethods, token, studentId;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            writeMethods = ['post', 'put', 'patch', 'delete'];
            if (writeMethods.includes(config.method.toLowerCase())) {
              if (!config.headers['X-Idempotency-Key']) {
                config.headers['X-Idempotency-Key'] = uuidv4();
              }
            }
            if (config.allowAnonymous) {
              _context2.next = 4;
              break;
            }
            _context2.next = 1;
            return auth.getAccessToken();
          case 1:
            token = _context2.sent;
            if (!(token != null)) {
              _context2.next = 2;
              break;
            }
            config.headers.common['Authorization'] = "Bearer " + token;
            _context2.next = 3;
            break;
          case 2:
            return _context2.abrupt("return", Promise.reject("Token is not valid"));
          case 3:
            studentId = getActiveStudent();
            if (config.params == null) {
              config.params = {};
            }
            if (studentId != null) config.params['studentId'] = studentId;
            return _context2.abrupt("return", config);
          case 4:
            return _context2.abrupt("return", config);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), function (error) {
    Promise.reject(error);
  });
};

// Export members
export default http;